import Loading from "components/common/Loading";
import React, { Suspense, useCallback, useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import style from "css/app.module.css";
import NotFound from "./common/notFound";
import Mypage from "./mypage/mypage";
import Meeting from "./meeting/meeting";
import Calendar from "./meeting/calendar";
import Room from "./meeting/room";
import Record from "./record/record";
import Header from "components/app/header";
import Wrapper from "components/app/wrapper";
import Container from "components/app/container";
import Menu from "components/app/menu";
import { useDispatch, useSelector } from "react-redux";
import { openAlert } from "redux/slices/alertSlice";
import Log from "./log/log";
import Notice from "./notice/notice";
import Realtime from "./realtime/realtime";
import Address from "./address/address";
import { ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";
import Reservation from "./reservation/reservation";
import HotDesking from "./hotdesking/HotDesking";
import MyReservation from "./reservation/myReservation";
import ReserveMeeting from "./log/reserveMeeting";

/**
 * 파일명: app.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: app router
 */
function App() {
  //state
  const [init, setInit] = useState(true);
  const [menuOpen, setMenuOpen] = useState(true);
  const [pageName, setPageName] = useState("");

  //location
  const location = useLocation();

  //dispatch
  const dispatch = useDispatch();

  //navigate
  const navigate = useNavigate();

  //translation
  const { t } = useTranslation();

  //payload
  const userPayload = useSelector((state) => state.user);
  const allowPagesPayload = useSelector((state) => state.allowPage);

  const checkAllowPage = useCallback(() => {
    const list = allowPagesPayload.pages;
    const pathName = new URL(window.location.href).pathname.split("/");
    const filter = list.filter((el) =>
      pathName[pathName.length - 1].includes(el.MENU_URL)
    );

    if (filter.length > 0) {
      return true;
    } else {
      return false;
    }
  }, [allowPagesPayload.pages]);

  useEffect(() => {
    if (userPayload.name !== "") {
      if (!checkAllowPage()) {
        dispatch(
          openAlert({
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.PAGE_NOT_AVAILABLE"),
            submitEventHandler: () =>
              navigate(
                process.env.REACT_APP_CLIENT_URL + "app/mypage/schedule"
              ),
          })
        );
      }
    }
  }, [checkAllowPage, dispatch, navigate, t, userPayload.name]);

  useEffect(() => {
    if (init) {
      if (location.state !== null && location.state !== undefined) {
        setMenuOpen(location.state.isMenuOpen);
      }
      setInit(false);
    }
  }, [init, location.state]);

  return (
    <div className={style.container}>
      <main className={style.main}>
        <Menu
          isOpen={menuOpen}
          setIsOpen={setMenuOpen}
          setPageName={setPageName}
        />

        <Wrapper isOpen={menuOpen}>
          <Header pageName={pageName} />
          <ConfigProvider
            theme={{
              token: {
                fontFamily: "Spoqa Han Sans Neo",
              },
              components: {
                Spin: {
                  colorPrimary: "#1cb691",
                },
                Pagination: {
                  colorPrimary: "#1cb691",
                },
              },
            }}
          >
            <Container>
              <Suspense fallback={<Loading />}>
                <Routes>
                  {/* <Route path="/reservation/*" element={<Reservation />} /> */}
                  {/* <Route path="/myStatus" element={<MyReservation />} /> */}
                  <Route path="/mypage/*" element={<Mypage />} />
                  <Route path="/record" element={<Record />} />
                  {/* <Route path="/log/*" element={<Log />} /> */}
                  <Route path="/rsrvMeeting" element={<ReserveMeeting />} />
                  <Route path="/address" element={<Address />} />
                  <Route path="/notice" element={<Notice />} />
                  <Route path="/meeting/*" element={<Meeting />} />
                  <Route path="/realtime/*" element={<Realtime />} />
                  <Route path="/hotdesking" element={<HotDesking />} />
                  <Route path="/calendar" element={<Calendar />} />
                  <Route path="/room" element={<Meeting />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </Container>
          </ConfigProvider>
        </Wrapper>
      </main>
    </div>
  );
}

export default App;
